var map = {
	"./account.svg": "7yHG",
	"./brower.svg": "6Yom",
	"./code.svg": "j8Uj",
	"./detail.svg": "mQDj",
	"./doc1.svg": "7rKs",
	"./doc2.svg": "q7L4",
	"./doc3.svg": "V1LH",
	"./info.svg": "iRml",
	"./ip.svg": "orBn",
	"./login-time.svg": "2fKi",
	"./login.svg": "Lo57",
	"./merchant.svg": "Ft4L",
	"./operation.svg": "KFNc",
	"./phone.svg": "bDN7",
	"./principal.svg": "qv2N",
	"./pwd.svg": "lQU/",
	"./query.svg": "jEPy",
	"./recharge.svg": "3guZ",
	"./record.svg": "q1X2",
	"./statistics.svg": "7F0Z",
	"./system.svg": "fkAr",
	"./time.svg": "P2ym",
	"./update-pass.svg": "Ayrf",
	"./user.svg": "EOg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 34